import { combineReducers } from 'redux';
import Leads from './Leads';
import Toast from './Toast';
import Inbox from './Inbox';
import GlobalSearch from './GlobalSearch';
import Admin from './Admin';
import Apartment from './Apartment';
import InboxSlice from './InboxV1';
import SelfServeSlice from './SelfServe';
import GlobalErrorSlice from './GlobalError';

export default combineReducers({
  Leads,
  Toast,
  Inbox,
  GlobalSearch,
  Admin,
  Apartment,
  slotsData: InboxSlice.reducer,
  inboxMessages: InboxSlice.reducer,
  SelfServe: SelfServeSlice.reducer,
  GlobalError: GlobalErrorSlice.reducer
});
